import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


let app = document.getElementById("app");
let props = {
  offset: app.getAttribute("data-offset") || -300,
};
const scrollProps = {
  yOffset: props.offset,
  element: app,
}
scrollProps.y = scrollProps.element.getBoundingClientRect().top + window.pageYOffset + scrollProps.yOffset

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    window.scrollTo({ top: scrollProps.y, behavior: 'smooth' });
  }
});

export default router
